//****************************************************************
// Imports
//****************************************************************
import $ from 'jquery';
import jQuery from 'jquery';
import Swiper from 'swiper/bundle';
import SwiperAnimation from '@cycjimmy/swiper-animation';
import SimpleLightbox from 'simplelightbox';

require("./bootstrap");
require("./jquery.easing.1.3");
require("./jquery.slideshow.js");

//****************************************************************
// Core
//****************************************************************
(function($, undefined) {

  //****************************************************************
  // Core Object
  //****************************************************************
  window.core = new (function Core() {
    var core = this;

    //****************************************************************
    // Handle
    //****************************************************************
    core.handle = new (function Handle() {
      var storageName = '__handles__';
      var handle = this;

      //****************************************************************
      handle.fn = {'sample': function(el) { return {}; }};

      //****************************************************************
      handle.get = function(selector, name) {
        var handles = $(selector).data(storageName);
        return handles ? (name ? (name in handles ? handles[name] : null) : handles) : null;
      };

      //****************************************************************
      handle.find = function(name) {
        return $('*').filter(function() {
          return handle.get(this, name) !== null;
        });
      };

      //****************************************************************
      handle.toggle = function(selector, toggle) {
        if (toggle) {
          handle.on(selector);
        } else {
          handle.off(selector);
        }
      };

      //****************************************************************
      handle.on = function(selector, names) {
        $(selector).each(function() {
          var el = this, $el = $(el), handles = $el.data(storageName) || {};
          $.each((names || $el.data('handle') || String()).split(' '), function() {
            if (this in handle.fn && !(this in handles)) {
              handles[this] = handle.fn[this].call(el) || {};
              $el.data(storageName, handles);
              if (typeof handles[this].on == 'function') {
                handles[this].on();
              }
            }
          });
        });
      };

      //****************************************************************
      handle.off = function(selector, names) {
        $(selector).each(function() {
          var el = this, $el = $(el), handles = $el.data(storageName) || {};
          $.each((names || $el.data('handle') || String()).split(' '), function() {
            if (this in handles) {
              if (typeof handles[this].off == 'function') {
                handles[this].off();
              }
              delete handles[this];
            }
          });
        });
      };
    });

    //****************************************************************
    // Toggle Handles
    //****************************************************************
    core.toggleHandles = function(selector, toggle) {
      if (toggle) {
        core.handle.on($('[data-handle]', selector));
      } else {
        core.handle.off($('[data-handle]', selector));
      }
    };

    //****************************************************************
    // Modal
    //****************************************************************
    core.modal = new (function Modal() {
      var modal = this, counter = 0, attr = 'data-modal-affect', attrMatch = attr + '-match';

      var style = document.createElement('style');
      document.head.appendChild(style);
      style.id = 'modal-rules';

      modal.on = function() {
        if (!counter++) {
          $(window).on('resize', modal.update);
        }
        modal.update();
      };
      modal.off = function() {
        if (!--counter) {
          $(window).off('resize', modal.update);
        }
        modal.update();
      };
      modal.state = function() {
        return !!counter;
      };
      modal.update = function() {
        $('[' + attrMatch + ']').each(function() { try { this.setAttribute(attr, window.matchMedia(this.getAttribute(attrMatch)).matches ? 'not' : 'can'); } catch(e) {}});
        if (modal.state()) {
          var size = core.getScrollBarSize()[0];
          $(document.documentElement).css({'overflow': 'hidden'});
          $(document.body).css({'margin-right': size});
          $('[' + attr + '="can"]').attr(attr, 'has').css({'margin-right': size});
          $('[' + attr + '="has"]').attr(attr, 'has').css({'margin-right': size});
          $('[' + attr + '="not"]').css({'margin-right': ''});
          while (style.sheet.cssRules.length) { style.sheet.deleteRule(0); }
          style.sheet.insertRule('.com-modal-affect { margin-right: ' + size + 'px; }', 0);
         } else {
          while (style.sheet.cssRules.length) { style.sheet.deleteRule(0); }
          $('[' + attr + '="can"]').attr(attr, 'can').css({'margin-right': ''});
          $('[' + attr + '="has"]').attr(attr, 'can').css({'margin-right': ''});
          $('[' + attr + '="not"]').css({'margin-right': ''});
          $(document.body).css({'margin-right': ''});
          $(document.documentElement).css({'overflow': ''});
        }
      };
    })();

    //****************************************************************
    // Get ScrollBar Size
    //****************************************************************
    core.getScrollBarSize = (function() {
      var el = window.document.createElement('textarea'), style = {
        'visibility': 'hidden', 'position': 'absolute', 'zIndex': '-2147483647',
        'top': '-1000px', 'left': '-1000px', 'width': '1000px', 'height': '1000px',
        'overflow': 'scroll', 'margin': '0', 'border': '0', 'padding': '0'
      }, support = el.clientWidth !== undefined && el.offsetWidth !== undefined;

      for (var key in style) {
        if (style.hasOwnProperty(key)) {
          el.style[key] = style[key];
        }
      }

      return function() {
        var size = null;
        if (support && window.document.body) {
          window.document.body.appendChild(el);
          size = [el.offsetWidth - el.clientWidth, el.offsetHeight - el.clientHeight];
          window.document.body.removeChild(el);
        }
        return size;
      };
    })();

    //****************************************************************
    // Animation Easings
    //****************************************************************
    core.easings = {
      linear: function(x) {
        return x;
      },
      easeInExpo: function(x) {
        return x === 0 ? 0 : Math.pow(2, 10 * x - 10);
      },
      easeOutExpo: function(x) {
        return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
      },
      easeInOutExpo: function(x) {
        return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2;
      }
    };

    //****************************************************************
    // Animation
    //****************************************************************
    core.animate = function(duration, easing, step) {
      var RAQID, starttime;
      function tick(timestamp) {
        var runtime = timestamp - starttime;
        step(easing(Math.min(Math.max(runtime / duration, 0), 1)));
        if (runtime < duration) {
          RAQID = window.requestAnimationFrame(tick);
        } else {
          RAQID = undefined;
        }
      }
      if (!easing) {
        easing = function (x) {
          return x;
        };
      }
      tick(starttime = performance.now());
      return function(p) {
        if (RAQID) {
          window.cancelAnimationFrame(RAQID);
          RAQID = undefined;
        }
        if (typeof p !== typeof undefined) {
          step(p);
        }
      };
    }

    //****************************************************************
    // Toggle Swipe Events
    //****************************************************************
    core.toggleSwipeEvents = function(selector, toggle) {
      $(selector).each(function() {
        var $selector = $(this);
        var dataStoreName = '__swipe_handler__';
        var handler = $selector.data(dataStoreName);
        if (toggle) {
          if (!handler) {
            handler = new (function() {
              var self = this, coords = null;
              self.getCoords = function(event) {
                if (event.touches && event.touches.length === 1) {
                  return [event.touches[0].pageX, event.touches[0].pageY];
                }
                return null;
              };
              self.onTouchStart = function(event) {
                coords = self.getCoords(event.originalEvent);
                event.stopPropagation();
              };
              self.onTouchMove = function(event) {
                if (coords) {
                  var newcoords = self.getCoords(event.originalEvent);
                  if (Math.abs(newcoords[0] - coords[0]) > Math.abs(newcoords[1] - coords[1])) {
                    if ((newcoords[0] - coords[0]) > 0) {
                      // swipe left
                      $(event.target).trigger('swipe-left')
                    } else {
                      // swipe right
                      $(event.target).trigger('swipe-right')
                    }
                  } else {
                    if ((newcoords[1] - coords[1]) > 0) {
                      // swipe up
                      $(event.target).trigger('swipe-up')
                    } else {
                      // swipe down
                      $(event.target).trigger('swipe-down')
                    }
                  }
                }
                coords = null;
                event.stopPropagation();
              };
              self.onTouchEnd = function(event) {
                coords = null;
                event.stopPropagation();
              };
              self.onTouchCancel = function(event) {
                coords = null;
                event.stopPropagation();
              };
              return self;
            })();
            $selector.data(dataStoreName, handler)
            .on('touchcancel', handler.onTouchCancel)
            .on('touchstart', handler.onTouchStart)
            .on('touchmove', handler.onTouchMove)
            .on('touchend', handler.onTouchEnd);
          }
        } else {
          if (handler) {
            $selector.data(dataStoreName, undefined)
            .off('touchcancel', handler.onTouchCancel)
            .off('touchstart', handler.onTouchStart)
            .off('touchmove', handler.onTouchMove)
            .off('touchend', handler.onTouchEnd);
          }
        }
      });
    };

    //****************************************************************
    // Lightbox
    //****************************************************************
    core.lightbox = function(options) {

      var defaults = {
        method        : null,
        target        : null,
        loader        : null,
        params        : null,
        animate       : true,
        history       : false,
        theme         : null,
        callback      : null
      };

      var animaDuration = 500;

      var uri = $('link[rel="canonical"]').attr('href');
      if (!uri) {
        uri = document.location.protocol + '//' + document.location.host + document.location.pathname + document.location.search;
      }

      var html = {
        modal         : '<div class="com-lightbox"><\/div>',
        outer         : '<div class="com-lightbox-outer"><\/div>',
        inner         : '<div class="com-lightbox-inner"><\/div>',
        outerContent  : '<div class="com-lightbox-outer-content"><\/div>',
        innerContent  : '<div class="com-lightbox-inner-content"><\/div>',
        loader        : '<div class="com-lightbox-window-outer"><div class="com-lightbox-window-inner"><div class="com-lightbox-loader"><\/div><\/div><\/div>',
      };

      var config = getConfig(options);

      var $modal = $(html.modal);
      var $outer = $(html.outer).css('opacity', 0.0);
      var $inner = $(html.inner);

      var $outerContent = $(html.outerContent);
      var $innerContent = $(html.innerContent).css('opacity', 0.0);

      $modal.attr('data-lightbox-theme', config.theme);
      $modal.append($outer.append($outerContent));
      $modal.append($inner.append($innerContent));

      phaseCreate(function() {
        toggleOuter(true);
        phaseLoad(function() {
          phasePlace(function() {
            phaseShow(function() {
              phaseBind();
            });
          });
        });
      });

      function getConfig(options) {
        var config = defaults;
        if (options) {
          $.extend(config, options);
        }
        if (!config.loader) {
          config.loader = html.loader;
        }
        return config;
      }

      function toggleOuter(toggle, callback) {
        var visibility = toggle ? 1.0 - (parseFloat($outer.css('opacity')) || 0.0) : (parseFloat($outer.css('opacity')) || 0.0);
        //$(document.documentElement).toggleClass('com-lightbox-effects');
        $outer.stop(true, true).animate({'opacity': toggle ? '1' : '0'}, config.animate ? animaDuration * visibility : 0, function() {
          callback && callback();
        });
      }

      function phaseCreate(callback) {
        core.modal.on();
        $(window.document.body).append($modal);
        callback && callback();
      }

      function phaseDestroy(callback) {
        $modal.remove();
        core.modal.off();
        callback && callback();
      }

      function phaseLoad(callback) {
        switch (config.method) {
          case 'get':
          case 'post':
            $.ajax({
              url: config.target,
              type: config.method,
              data: config.params,
              dataType: 'html',
              cache: false,
              beforeSend: function(jqXHR, settings) {
                $outerContent.append(config.loader ? config.loader : html.loader);
              },
              success: function(data, textStatus, jqXHR) {
                if (jqXHR.status == 200 && data) {
                  config.content = data;
                  //$outerContent.empty();
                  callback && callback();
                } else {
                  alert('HTTP Error: ' + jqXHR.status);
                  toggleOuter(false, function() {
                    phaseDestroy();
                  })
                }
              },
              error: function(jqXHR, textStatus, errorThrown) {
                //alert('HTTP Error: ' + jqXHR.status);
                toggleOuter(false, function() {
                  phaseDestroy();
                })
              }
            });
            break;
          default:
            config.content = $(config.target).clone().show();
            callback && callback();
            break;
        }
      }

      function phaseUnload(callback) {
        config.target = null;
        callback && callback();
      }

      function phasePlace(callback) {
        $innerContent.append(config.content);
        core.toggleHandles($innerContent, true);
        if (config.history && window.history && window.history.replaceState) {
          window.history.replaceState(null, document.title, config.target);
        }
        $modal.trigger('com-lightbox-ready');
        window.setTimeout(function() {
          //core.waitForLoading($innerContent).done(function() {
            $outerContent.empty();
            $modal.trigger('com-lightbox-load');
            callback && callback();
          //});
        }, 0);
      }

      function phaseRemove(callback) {
        $modal.trigger('com-lightbox-unload');
        $modal.trigger('com-lightbox-reset');
        core.toggleHandles($innerContent, false);
        $innerContent.empty();
        if (config.history && window.history && window.history.replaceState) {
          window.history.replaceState(null, document.title, uri);
        }
        callback && callback();
      }

      function phaseShow(callback) {
        var visibility = 1.0 - (parseFloat($innerContent.css('opacity')) || 0.0);
        $innerContent.stop(true, true).animate({'opacity': '1'}, config.animate ? animaDuration * visibility : 0, function() {
          $innerContent.css({'opacity': ''});
          $modal.trigger('com-lightbox-show');
          callback && callback();
        });
      }

      function phaseHide(callback) {
        var visibility = parseFloat($innerContent.css('opacity')) || 0.0;
        $innerContent.stop(true, true).animate({'opacity': '0'}, config.animate ? animaDuration * visibility : 0, function() {
          $innerContent.css({'opacity': '0'});
          $modal.trigger('com-lightbox-hide');
          callback && callback();
        });
      }

      function phaseBind(callback) {
        $modal.on('com-lightbox-open com-lightbox-close', onEvent);
        $('[data-lightbox-role="close"]', $innerContent).on('click', onCloseClick);
        callback && callback();
      }

      function phaseUnbind(callback) {
        $modal.off('com-lightbox-open com-lightbox-close', onEvent);
        $('[data-lightbox-role="close"]', $innerContent).off('click', onCloseClick);
        callback && callback();
      }

      function onEvent(event, options) {
        if (event.currentTarget == event.target) {
          switch (event.type) {
            case 'com-lightbox-open':
              phaseUnbind(function() {
                phaseHide(function() {
                  phaseRemove(function() {
                    phaseUnload(function() {
                      config = getConfig(options);
                      $modal.attr('data-lightbox-theme', config.theme);
                      phaseLoad(function() {
                        phasePlace(function() {
                          phaseShow(function() {
                            phaseBind();
                          });
                        });
                      });
                    });
                  });
                });
              });
            break;
            case 'com-lightbox-close':
              toggleOuter(false);
              phaseUnbind(function() {
                phaseHide(function() {
                  phaseRemove(function() {
                    phaseUnload(function() {
                      phaseDestroy(function() {
                      });
                    });
                  });
                });
              });
            break;
          }
        }
        event.preventDefault();
      };

      function onCloseClick(event) {
        $modal.trigger('com-lightbox-close');
        event.preventDefault();
      }

      return false;
    };

    //****************************************************************
    // HANDLE: lightbox
    //****************************************************************
    core.handle.fn['lightbox'] = function() {
      return new (function(el) {
        var self = this;

        var $el = $(el);

        function onClick(event) {
          var options = {
            method:  $el.attr('data-lightbox-method') || 'get',
            target:  $el.attr('data-lightbox-target') || $el.attr('href') || null,
            theme:   $el.attr('data-lightbox-theme')  || null,
          };
          if (options.target) {
            core.lightbox(options);
          }
          event.preventDefault();
        };

        function onSubmit(event) {
          var options = {
            method:  $el.attr('data-lightbox-method') || $el.attr('method') || 'get',
            target:  $el.attr('data-lightbox-target') || $el.attr('action') || null,
            theme:   $el.attr('data-lightbox-theme')  || null,
          };
          if (options.target) {
            core.lightbox(options);
          }
          event.preventDefault();
        };

        self.on = function() {
          if ($el.prop('tagName') == 'FORM') {
            $el.on('submit', onSubmit);
          } else {
            $el.on('click', onClick);
          }
        };

        self.off = function() {
          if ($el.prop('tagName') == 'FORM') {
            $el.off('submit', onSubmit);
          } else {
            $el.off('click', onClick);
          }
        };

      })(this);
    };

    //****************************************************************
    // HANDLE: radioview
    //****************************************************************
    core.handle.fn['radioview'] = function() {
      return new (function(el) {
        var self = this;

        var $el = $(el);
        var $selectors = $('[data-radioview-role="selector"]', $el);
        var $optionors = $('[data-radioview-role="optionor"]', $el);

        function init() {
          var $selector = $selectors.filter('.com-active');
          if (!$selector.length) {
            $selector = $selectors.first();
          }
          select($selector.attr('data-radioview-name'));
        }

        function select(name) {
          if (name) {
            $selectors.removeClass('com-active');
            $optionors.removeClass('com-active');
            $selectors.filter('[data-radioview-name="' + name + '"]').addClass('com-active');
            $optionors.filter('[data-radioview-name="' + name + '"]').addClass('com-active');
          }
        }

        function onClickSelector(event) {
          select($(this).attr('data-radioview-name'));
          event.preventDefault();
        }

        self.on = function() {
          init();
          $selectors.on('click', onClickSelector);
        };

        self.off = function() {
          $selectors.off('click', onClickSelector);
        };

      })(this);
    };

    //****************************************************************
    // HANDLE: gallery
    //****************************************************************
    core.handle.fn['gallery'] = function() {
      return new (function(el) {
        var self = this;

        var $el = $(el);
        var lightbox = null;

        function onOpen(event) {
          if (lightbox) {
            lightbox.open();
          }
          event.preventDefault();
        }

        self.on = function() {
          lightbox = new SimpleLightbox($('a', $el), {
            htmlClass: 'has-lightbox',
            disableScroll: false,
            scrollZoom: false,
            overlayOpacity: 1
          });
          lightbox.on('show.simplelightbox', function () {
            core.modal.on();
          });
          lightbox.on('closed.simplelightbox', function () {
            core.modal.off();
          });
          $el.on('gallery-open', onOpen);
        };

        self.off = function() {
          lightbox.destroy();
          lightbox = null;
          $el.off('gallery-open', onOpen);
        };

      })(this);
    };

    //****************************************************************
    // HANDLE: gallery-open
    //****************************************************************
    core.handle.fn['gallery-open'] = function() {
      return new (function(el) {
        var self = this;

        var $el = $(el);

        function onClick(event) {
          var name = $el.attr('data-gallery-target');
          if (name) {
            var $target = $('[data-gallery-name="' + name + '"]');
            if ($target.length) {
              $target.trigger('gallery-open');
            }
          }
          event.preventDefault();
        }

        self.on = function() {
          $el.on('click', onClick);
        };

        self.off = function() {
          $el.off('click', onClick);
        };

      })(this);
    };

    //****************************************************************
    // HANDLE: cookie-popup
    //****************************************************************
    core.handle.fn['cookie-popup'] = function() {
      return new (function(el) {
        var self = this;

        var $el = $(el);
        var $close = $('[data-cookie-popup-role="close"]', $el);

        var cookie = $el.attr('data-cookie-popup') || 'cookie-popup';

        function setCookie(name, value, days) {
          var expires = '';
          if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
          }
          document.cookie = name + '=' + (value || '')  + expires + '; path=/';
        }

        function onClickClose(event) {
          self.off();
          setCookie(cookie, 'ok', 1);
          $el.remove();
        }

        self.on = function() {
          $close.on('click', onClickClose);
        };

        self.off = function() {
          $close.off('click', onClickClose);
        };

      })(this);
    };


    //****************************************************************
    // HANDLE: media
    //****************************************************************
    core.handle.fn['media'] = function() {

      return new (function(el) {
        var self = this;

        const packs = [];

        function update() {
          let src = null;
          packs.every(function(pack) {
            if (pack.mql.matches) {
              src = pack.source.src;
              return false;
            }
            return true;
          });
          if (src !== el.currentSrc) {
            el.src = src;
          }
        }

        function onChange(event) {
          update();
        }

        self.on = function() {
          self.off();
          if (el.tagName == 'AUDIO' || el.tagName == 'VIDEO') {
            Array.from(el.querySelectorAll('source')).forEach(function(source) {
              if (el.canPlayType(source.getAttribute('type') || '')) {
                const mql = window.matchMedia(source.getAttribute('media') || '');
                mql.addEventListener('change', onChange);
                packs.push({source, mql});
              }
            });
          }
        };

        self.off = function() {
          while (packs.length) {
            const pack = packs.pop();
            pack.mql.removeEventListener('change', onChange);
          }
        };

      })(this);

    };

    //****************************************************************
    // HANDLE: timeline
    //****************************************************************
    core.handle.fn['timeline'] = function() {

      /****************************************/
      // TIMELINE A
      /****************************************/
      function comTimelineA(el) {
        var self = this;

        var items  = el.querySelectorAll('[data-timeline-role="item"]');
        var actors = el.querySelectorAll('[data-timeline-role="actor"]');

        function animations(toggle) {
          if (toggle) {
            animations.raq = window.requestAnimationFrame(function() {
              animations.raq = window.requestAnimationFrame(function() {
                el.classList.add('com-animate');
                delete animations.raq;
              });
            });
          } else {
            el.classList.remove('com-animate');
            if (animations.raq) {
              window.cancelAnimationFrame(animations.raq);
              delete animations.raq;
            }
          }
        }

        function resetItems() {
          el.classList.remove('com-active');
          items.forEach(function(item) {
            if (item.classList.contains('com-active')) {
              item.classList.remove('com-active');
              item.querySelectorAll('video').forEach(function(video) {
                video.pause();
              });
            }
          });
        }

        function setupItem(item) {
          if (item && !item.classList.contains('com-active')) {
            resetItems();
            item.classList.add('com-active');
            item.querySelectorAll('video').forEach(function(video) {
              video.currentTime = 0;
              video.play();
            });
          }
        }

        function onClickItem(event) {
          setupItem(this.closest('[data-timeline-role="item"]'));
          event.preventDefault();
        }

        function onClickDocument(event) {
          if (!event.target.closest('[data-timeline-role="item"]')) {
            resetItems();
          }
        }

        self.on = function() {
          animations(true);
          actors.forEach(function(actor) {
            actor.addEventListener('click', onClickItem);
          });
          document.addEventListener('click', onClickDocument);
        };

        self.off = function() {
          animations(false);
          resetItems();
          actors.forEach(function(actor) {
            actor.removeEventListener('click', onClickItem);
          });
          document.removeEventListener('click', onClickDocument);
        };

      }

      /****************************************/
      // TIMELINE B
      /****************************************/
      function comTimelineB(el) {
        var self = this;

        var items  = el.querySelectorAll('[data-timeline-role="item"]');
        var actors = el.querySelectorAll('[data-timeline-role="actor"]');

        var animaEasing   = core.easings.easeOutExpo;
        var animaDuration = 500;

        function animations(toggle) {
          if (toggle) {
            animations.raq = window.requestAnimationFrame(function() {
              animations.raq = window.requestAnimationFrame(function() {
                el.classList.add('com-animate');
                delete animations.raq;
              });
            });
          } else {
            el.classList.remove('com-animate');
            if (animations.raq) {
              window.cancelAnimationFrame(animations.raq);
              delete animations.raq;
            }
          }
        }

        function resetItems() {
          items.forEach(function(item) {
            var drop = item.querySelector('[data-timeline-role="drop"]');
            if (drop) {
              if (item._anima_) {
                item._anima_(0);
                drop.style.height = '';
                delete item._anima_;
              }
            }
            if (item.classList.contains('com-active')) {
              item.classList.remove('com-active');
              item.querySelectorAll('video').forEach(function(video) {
                video.pause();
              });
            }
          });
        }

        function setupItem(item) {
          if (item && !item._anima_) {
            var drop = item.querySelector('[data-timeline-role="drop"]');
            if (drop && drop.children.length) {
              if (!item.classList.contains('com-active')) {
                item.classList.add('com-active');
                item.querySelectorAll('video').forEach(function(video) {
                  video.currentTime = 0;
                  video.play();
                });
                item._anima_ = core.animate(animaDuration, animaEasing, function(x) {
                  var height = drop.children[0].clientHeight;
                  if (x < 1) {
                    drop.style.height = (x * height) + 'px';
                  } else {
                    drop.style.height = '';
                    delete item._anima_;
                  }
                });
              } else {
                item.classList.remove('com-active');
                item.querySelectorAll('video').forEach(function(video) {
                  video.pause();
                });
                item._anima_ = core.animate(animaDuration, animaEasing, function(x) {
                  var height = drop.children[0].clientHeight;
                  if (x < 1) {
                    drop.style.height = ((1 - x) * height) + 'px';
                  } else {
                    drop.style.height = '';
                    delete item._anima_;
                  }
                });
              }
            }
          }
        }

        function onClickItem(event) {
          setupItem(this.closest('[data-timeline-role="item"]'));
          event.preventDefault();
        }

        self.on = function() {
          animations(true);
          actors.forEach(function(actor) {
            actor.addEventListener('click', onClickItem);
          });
        };

        self.off = function() {
          animations(false);
          resetItems();
          actors.forEach(function(actor) {
            actor.removeEventListener('click', onClickItem);
          });
        };

      }

      /****************************************/
      // TIMELINE
      /****************************************/
      return new (function(el) {
        var self = this;

        var behavior = null;

        var mql = matchMedia('screen and (max-width: 1000px)');

        function mqe(mql) {
          setupBehavior();
        };

        function resetBehavior() {
          behavior && behavior.off();
          behavior = null;
        }

        function setupBehavior() {
          resetBehavior();
          if (!mql.matches) {
            behavior = new comTimelineA(el);
          } else {
            behavior = new comTimelineB(el);
          }
          behavior.on();
        }

        self.on = function() {
          mql.addEventListener("change", mqe);
          setupBehavior();
        };

        self.off = function() {
          mql.removeEventListener("change", mqe);
          resetBehavior();
        };

      })(this);
    };

    //****************************************************************
    // HANDLE: generic-slider
    //****************************************************************
    core.handle.fn['generic-slider'] = function() {
      return new (function(el) {
        var self = this;

        var swiperObject    = null;
        var swiperAnimation = new SwiperAnimation();

        function createSwiper() {
          var $swiper = $('[data-generic-slider-role="swiper"]', el);
          var $slides = $('[data-generic-slider-role="slide"]', el);

          if (!swiperObject && $swiper.length && $slides.length) {

            swiperObject = new Swiper($swiper.get(0), {
              slidesPerView: 1,
              slidesPerGroup: 1,
              spaceBetween: 0,
              autoHeight: true,
              speed: 1000,
              grabCursor: true,
              navigation: {
                nextEl: el.querySelector('[data-generic-slider-role="next"]'),
                prevEl: el.querySelector('[data-generic-slider-role="prev"]'),
              },
              pagination: {
                el: el.querySelector('[data-generic-slider-role="pagination"]'),
                clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="' + className + '"><span class="bullet"></span><span class="text">'+ $slides.eq(index).data('generic-slider-title') +'</span></span>';
                },
              },
              on: {
                init: function () {
                  swiperAnimation.init(this).animate();
                },
                slideChange: function () {
                  swiperAnimation.init(this).animate();
                }
              }
            });
          }
        }

        function destroySwiper() {
          if (swiperObject) {
            swiperObject.destroy();
          }
        }

        self.on = function() {
          createSwiper();
        };

        self.off = function() {
          destroySwiper();
        };

      })(this);
    };

    //****************************************************************
    // HANDLE: slideshow
    //****************************************************************
    core.handle.fn['slideshow'] = function() {

      //****************************************************************

      return new (function(el) {
        var self = this;

        //****************************************************************

        var $slideshow    = $(el);
        var $slideList    = $('.com-slides', $slideshow).first();
        var $thumbList    = $('.com-thumbs', $slideshow).first();
        var $slideItems   = $('.com-slide', $slideList);
        var $thumbItems   = $('.com-thumb', $thumbList);
        var $slideHovers  = $('.com-hover', $slideItems);
        var $arrowPrev    = $('.com-arrow-prev', $slideshow);
        var $arrowNext    = $('.com-arrow-next', $slideshow);
        var $swiper       = $('.com-swiper', $slideshow);

        //****************************************************************
        // prefix

        var prefix = 'slideshow';

        //****************************************************************
        // options
        var options = {
          prefix      : prefix,
          animation   : 'custom',
          play        : true,
          continuous  : true,
          reverse     : false,
          index       : 0,
          pauseTime   : 7000,
          switchTime  : 1000,
          easing      : 'linear',
          callback    : callback
        };

        //****************************************************************
        // support related

        if (core.isTouch && core.isTouch()) {
          $slideshow.addClass('com-support-touch');
        }

        //****************************************************************
        // preload

        function init(state) {
          if (state) {
            activate();
          } else {
            deactivate();
          }
        };

        //****************************************************************
        // callback

        function callback(index, reason) {
          $thumbItems.attr('data-thumb-active', 0).eq(index).attr('data-thumb-active', '1');
          $slideItems.attr('data-slide-active', 0).eq(index).attr('data-slide-active', '1');
        };

        //****************************************************************

        function activate() {

          /* init container */
          $slideshow.addClass('com-active');

          /* init slideshow */
          $slideList.slideshow(options);
          $thumbItems.attr('data-thumb-active', 0).first().attr('data-thumb-active', '1');
          $slideItems.attr('data-slide-active', 0).first().attr('data-slide-active', '1');

          /* swipes */
          core.toggleSwipeEvents($swiper, true);
          $swiper.on('swipe-left.' + prefix, function() {
            $slideList.trigger(prefix + '-stop').trigger(prefix + '-prev');
            options.play = false;
          }).on('swipe-right.' + prefix, function() {
            $slideList.trigger(prefix + '-stop').trigger(prefix + '-next');
            options.play = false;
          }).on('click.' + prefix, function() {
            $slideList.trigger(prefix + '-stop').trigger(prefix + '-next');
            options.play = false;
          });

          /* thumbs */
          $thumbItems.on('click.' + prefix, function(event) {
            var index = $thumbItems.index(this);
            //$thumbItems.attr('data-thumb-active', 0).eq(index).attr('data-thumb-active', '1');
            $slideList.trigger(prefix + '-stop').trigger(prefix + '-show', index);
            options.play = false;
            event.preventDefault();
          });

          /* arrows */
          $arrowPrev.on('click.' + prefix, function(event) {
            $slideList.trigger(prefix + '-stop').trigger(prefix + '-prev');
            options.play = false;
            event.preventDefault();
          });
          $arrowNext.on('click.' + prefix, function(event) {
            $slideList.trigger(prefix + '-stop').trigger(prefix + '-next');
            options.play = false;
            event.preventDefault();
          });

          // focus/blur
          $(window).on('focus.' + prefix, function() {
            if (options.play) {
              $slideList.trigger(prefix + '-play', true);
            }
          }).on('blur.' + prefix, function() {
            if (options.play) {
              $slideList.trigger(prefix + '-stop');
            }
          });

        };

        //****************************************************************

        function deactivate() {
          $slideshow.removeClass('com-active');
          $slideList.trigger(prefix + '-kill');
          $thumbItems.attr('data-thumb-active', null);
          $slideItems.attr('data-slide-active', null);
          core.toggleSwipeEvents($swiper, false);
          $slideshow.off('wheel.' + prefix);
          $swiper.off('swipe-left.' + prefix).off('swipe-right.' + prefix).off('click.' + prefix);
          $thumbItems.off('click.' + prefix);
          $arrowPrev.off('click.' + prefix);
          $arrowNext.off('click.' + prefix);
          $(window).off('focus.' + prefix).off('blur.' + prefix)
        };

        //****************************************************************

        self.on = function() {
          init(true);
        };

        self.off = function() {
          init(false);
        };

        //****************************************************************

      })(this);

      //****************************************************************

    };

    //****************************************************************
    // HANDLE: wiggle
    //****************************************************************
    core.handle.fn['wiggle'] = function() {
      return new (function(el) {
        var self = this;

        function wiggleText() {
            let globalIndex = 0;

            function processNode(node) {
              if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.classList && node.classList.contains('wiggle-word')) {
                  return;
                }
                Array.from(node.childNodes).forEach(processNode);
              }
              else if (node.nodeType === Node.TEXT_NODE) {
                const text = node.textContent;
                if (!text) return;

                const fragment = document.createDocumentFragment();

                const parts = text.match(/([\u00A0\S]+|\s+)/g);

                if (!parts) return;

                parts.forEach((part) => {
                  if (/^\s+$/.test(part)) {
                    fragment.appendChild(document.createTextNode(part));
                  } else {
                    const wordSpan = document.createElement('span');
                    wordSpan.className = 'wiggle-word';
                    wordSpan.style.display = 'inline-block';
                    wordSpan.style.whiteSpace = 'nowrap';

                    [...part].forEach((char) => {
                      const letterSpan = document.createElement('span');
                      letterSpan.className = 'wiggle-letter';
                      letterSpan.style.display = 'inline-block';
                      letterSpan.style.setProperty('--i', globalIndex++);
                      letterSpan.setAttribute('aria-hidden', 'true');
                      letterSpan.textContent = char;

                      wordSpan.appendChild(letterSpan);
                    });

                    fragment.appendChild(wordSpan);
                  }
                });

                node.parentNode.replaceChild(fragment, node);
              }
            }

            processNode(el);
            el.classList.add('activate');
        }

        self.on = function() {
          wiggleText();
        };

        self.off = function() {
        };

      })(this);
    };

    //****************************************************************

  })();

  //****************************************************************
  // PAGE READY
  //****************************************************************
  $(function() {
    if (document.body) {

      // detect mobile
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini|Mobile/i.test(navigator.userAgent)) {
        document.body.classList.add("platform-mobile");
      } else {
        document.body.classList.add("platform-desktop");
      }

      // toggle handles ON
      core.toggleHandles(document.body, true);
      $(document).on('handle', function(event, selector, trigger) {
        console.log("trggered");
        core.toggleHandles(selector, trigger);
      });

    }
  });

  //****************************************************************

})(jQuery);
